module.exports = __webpack_public_path__ + "img/logo-peace-white-stroke.49839a06.png";